/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface JobTitleWithOrigin
 */
export interface JobTitleWithOrigin {
    /**
     * 
     * @type {string}
     * @memberof JobTitleWithOrigin
     */
    value: string;
    /**
     * 
     * @type {Origin}
     * @memberof JobTitleWithOrigin
     */
    origin: Origin;
}

/**
 * Check if a given object implements the JobTitleWithOrigin interface.
 */
export function instanceOfJobTitleWithOrigin(value: object): value is JobTitleWithOrigin {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function JobTitleWithOriginFromJSON(json: any): JobTitleWithOrigin {
    return JobTitleWithOriginFromJSONTyped(json, false);
}

export function JobTitleWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobTitleWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'origin': OriginFromJSON(json['origin']),
    };
}

export function JobTitleWithOriginToJSON(value?: JobTitleWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'origin': OriginToJSON(value['origin']),
    };
}

